import React, { useState, useEffect } from 'react';
import { notificationService } from '../NotificationService';
import { AlertCircle, ArrowRight, X } from 'lucide-react';

const StudentAlertBanner = ({ user, navigate }) => {
    const [latestAssignment, setLatestAssignment] = useState(null);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (!user || user.role !== 'student') return;

        const unsubscribe = notificationService.listenToNotifications(user.uid, (data) => {
            // Find the latest unread assignment notification
            const unreadAssignments = data.all.filter(n =>
                !n.isRead && n.type === 'assignment'
            );

            if (unreadAssignments.length > 0) {
                // Get the most recent one
                setLatestAssignment(unreadAssignments[0]);
                setIsVisible(true);
            } else {
                setLatestAssignment(null);
            }
        });

        return () => unsubscribe();
    }, [user]);

    if (!latestAssignment || !isVisible) return null;

    const handleNavigate = () => {
        if (navigate) {
            // Mark as read when clicked
            notificationService.markAsRead(user.uid, latestAssignment.id).catch(console.error);

            if (latestAssignment.data?.assignmentType === 'soal') {
                navigate('siswa_soal', { selectedSoalId: latestAssignment.data.assignmentId });
            } else if (latestAssignment.data?.assignmentType === 'lkpd') {
                navigate('siswa_lkpd', { selectedLkpdId: latestAssignment.data.assignmentId });
            } else {
                navigate('siswa_dashboard');
            }
            setIsVisible(false);
        }
    };

    return (
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-3 shadow-md relative z-20">
            <div className="container mx-auto flex items-center justify-between">
                <div className="flex items-center gap-3 overflow-hidden">
                    <div className="bg-white/20 p-1.5 rounded-full animate-pulse flex-shrink-0">
                        <AlertCircle size={18} />
                    </div>
                    <div className="min-w-0">
                        <p className="font-medium text-sm md:text-base truncate">
                            {latestAssignment.title}
                        </p>
                        <p className="text-xs text-blue-100 hidden md:block truncate">
                            {latestAssignment.message}
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 ml-2">
                    <button
                        onClick={handleNavigate}
                        className="bg-white text-blue-600 px-3 py-1.5 rounded-full text-xs md:text-sm font-bold hover:bg-blue-50 transition-colors flex items-center gap-1 whitespace-nowrap"
                    >
                        Cek <span className="hidden sm:inline">Sekarang</span> <ArrowRight size={14} />
                    </button>
                    <button
                        onClick={() => setIsVisible(false)}
                        className="text-white/70 hover:text-white"
                    >
                        <X size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StudentAlertBanner;
